function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import MobileMenuItem from './MobileMenuItem.react';
var MobileMenu = function MobileMenu() {
  var cmsNavItems = useSelector(function (s) {
    return s.app.navigation || {};
  });
  var toggle = useSelector(function (s) {
    return s.app.toggleHamburgerMenu;
  });
  var clientEnv = useSelector(function (s) {
    return s.app.clientEnv;
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    navItems = _useState2[0],
    setNavItems = _useState2[1];
  var close = function close() {
    return $('.mm').css({
      left: -1 * $('.mm').width()
    });
  };
  var open = function open() {
    return $('.mm').css({
      left: 0
    });
  };
  useEffect(function () {
    if (!toggle) {
      close();
      return;
    }
    if ($('.mm').position().left === 0) close();else open();
  }, [toggle]);
  useEffect(function () {
    setNavItems(Object.values(cmsNavItems).filter(function (x) {
      return x.navbar === 'mobile-menu';
    }).filter(function (x) {
      var published = false;
      x.published.forEach(function (y) {
        if ((clientEnv === 'local' || y.clientEnv === clientEnv) && y.published !== false) published = true;
      });
      if (published) return x;
    }).sort(function (a, b) {
      return a.slot - b.slot;
    }));
  }, [cmsNavItems]);
  return /*#__PURE__*/React.createElement("div", {
    id: "mobile-menu",
    className: "mm"
  }, navItems.map(function (x) {
    return /*#__PURE__*/React.createElement(MobileMenuItem, _extends({}, x, {
      key: 'mm' + x._id
    }));
  }), /*#__PURE__*/React.createElement("div", {
    className: "mm-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: ['mm-item__parent', 'mm__social'].join(' ')
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/Posillico-wash-plant",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/social-icons/facebook-icon.png"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.linkedin.com/company/posillico-wash-plant",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/social-icons/linkedin-icon.png"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.instagram.com/posillico_washplant",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/social-icons/instagram-icon.png"
  })))));
};
export default MobileMenu;